import { CampaignsNetworkContext } from '@/context';
import { useContext } from 'react';

export default () => useContext(CampaignsNetworkContext);
